import logo from './uppies.gif';
import './App.css';
import bg from './bg.png'
import sound__fart from './fart.wav'
import React from 'react'
function App() {
    const soundRef__fart = React.createRef(null)
    const ferp = () => {
        soundRef__fart.current.currentTime = 0
        soundRef__fart.current.play()
    }
  return (
    <div onClick={ferp} className="App" style={{backgroundImage: `url(${bg})`}}>
       <audio ref={soundRef__fart}>
                <source src={sound__fart} type="audio/wav" />
                Your browser does not support the audio element.
              </audio>
    </div>
  );
}

export default App;
